/* Slideshow : Get content height for placing navigation buttons */
const slideshows = document.querySelectorAll('.slideshow');
slideshows.forEach((slideshow) => {
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    slides.forEach((slide) => {
        const content = slide.querySelector('.slide-content');
        if (content) {
            const contentHeight = content.offsetHeight;
            slide.style.setProperty('--content-height', contentHeight + 'px');
        }
    });
});
const slideNavigations = document.querySelectorAll('.slideshow__controls');

// Met à jour la position top des contrôles selon la hauteur du contenu de la slide sélectionnée
function updateSlideshowControlsPosition() {
    if (window.innerWidth >= 1000) {
        const selectedSlide = document.querySelector('.slideshow__slide.is-selected');
        const controls = document.querySelectorAll('.slideshow__controls');
        const anySlide = document.querySelector('.slideshow__slide');
        if (selectedSlide && anySlide) {
            const contentHeightStr = getComputedStyle(selectedSlide).getPropertyValue('--content-height');
            const slideHeight = anySlide.offsetHeight;
            const contentHeight = parseFloat(contentHeightStr);
            if (!isNaN(contentHeight) && slideHeight) {
                const top = ((slideHeight - contentHeight) / 2) + contentHeight - 20;
                controls.forEach(control => {
                    control.style.transition = 'top 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.5s cubic-bezier(0.4,0,0.2,1)';
                    control.style.top = top + 'px';
                });
            } else {
                controls.forEach(control => {
                    control.style.top = contentHeightStr ? contentHeightStr : '';
                });
            }
        }
    } else {
        const controls = document.querySelectorAll('.slideshow__controls');
        controls.forEach(control => {
            control.style.top = '';
            control.style.transition = '';
        });
    }
}

updateSlideshowControlsPosition();

window.addEventListener('resize', updateSlideshowControlsPosition);
document.addEventListener('DOMContentLoaded', () => {
    updateSlideshowControlsPosition();
});

// Observer les changements de classe sur les slides pour détecter le changement de slide sélectionnée
const slidesContainer = document.querySelector('.slideshow');
if (slidesContainer) {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const controls = document.querySelectorAll('.slideshow__controls');
                controls.forEach(control => {
                    control.style.transition = 'opacity 0.3s';
                    control.style.opacity = '0';
                });
                setTimeout(() => {
                    updateSlideshowControlsPosition();
                    controls.forEach(control => {
                        control.style.transition = 'opacity 0.3s';
                        control.style.opacity = '1';
                    });
                }, 200);
                break;
            }
        }
    });
    const slides = slidesContainer.querySelectorAll('.slideshow__slide');
    slides.forEach(slide => {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
}